<template>
    <type-wrapper class="success" regular>
        <type-grid row="13" margin>
            <type-image mode="widthFix" :src="image"></type-image>
        </type-grid>
        <type-grid row="23" margin v-if="orderList.length">
            <type-grid row="11" margin style="margin-top: 0;margin-bottom: 0;">
                <type-text type="content" size="6" align="center">Payment Successful</type-text>
            </type-grid>
            <type-grid row="11" margin>
                <type-text type="content" size="6" align="center">Order Confirmed</type-text>
            </type-grid>
            <type-grid row="11" margin v-if="orderList.length">
                <div id="order-html">
                    <div class="single-order" v-for="(item, index) in orderList" :key="index">
                        <type-text type="content" size="6" align="center">Order {{index + 1}}</type-text>
                        <type-text type="content" size="6" align="center">Order Number: {{item.order_unique_id}}</type-text>
                        <type-text type="content" size="6" align="center">Product Name: {{item.product_name}}</type-text>
                        <type-text type="content" size="6" align="center">Product Description: {{item.product_description}}</type-text>
                        <type-text type="content" size="6" align="center">Quantity: {{item.quantity}}</type-text>
                        <type-text type="content" size="6" align="center">Unit Price: {{item.final_price/100}}</type-text>
                        <type-text type="content" size="6" align="center">Currency: {{item.currency}}</type-text>
                        <type-text type="content" size="6" align="center">Buyer Name: {{item.receiver_name}}</type-text>
                        <type-text type="content" size="6" align="center">Payment Status: {{item.is_payment_complete ? 'Paid' : 'Unpaid'}}</type-text>
                        <type-text type="content" size="6" align="center">
                            <span>Digital Delivery: </span>
                            <span v-html="formatDigitalDelivery(item.notes)"></span>
                        </type-text>
                    </div>
                </div>
            </type-grid>
            <type-grid row="11" margin v-if="orderList.length">
                <type-button whitebackdrop v-print="'#order-html'" border>Print Order</type-button>
            </type-grid>
        </type-grid>
        <type-grid row="23" margin v-else>
            <type-grid row="11" margin style="margin-top: 0;margin-bottom: 0;">
                <type-text type="title" size="9">No Order Information Available</type-text>
            </type-grid>
        </type-grid>
    </type-wrapper>
</template>

<script>
export default {
    name: 'success',
    data() {
        return {
            orderList: [],
            image: require('../../assets/image/about-img.jpg'), // 默认图片
            pageData: null // 存储页面数据
        }
    },
    async created() {
        // 页面加载时获取页面数据和订单数据
        await this.getPageData();
        await this.getOrderData();
    },
    methods: {
        // 格式化数字交付内容，将URL转换为可点击的链接
        formatDigitalDelivery(notes) {
            if (!notes) {
                return 'N/A';
            }

            // URL正则表达式，匹配http和https链接
            const urlRegex = /(https?:\/\/[^\s,;"'<>]+)/g;
            
            // 检查是否包含URL
            if (urlRegex.test(notes)) {
                // 重置正则表达式的lastIndex
                urlRegex.lastIndex = 0;
                
                // 替换所有URL为可点击的链接
                const formattedText = notes.replace(urlRegex, (url) => {
                    // 清理URL，移除可能的引号和逗号
                    const cleanUrl = url.replace(/[",;]+$/, '');
                    
                    // 从URL中提取文件名用作显示文本
                    const fileName = this.extractFileName(cleanUrl);
                    
                    return `<a href="${cleanUrl}" target="_blank" rel="noopener noreferrer" class="download-link">${fileName || cleanUrl}</a>`;
                });
                
                return formattedText;
            }
            
            // 如果没有URL，返回原始文本
            return notes;
        },

        // 从URL中提取文件名
        extractFileName(url) {
            try {
                // 移除查询参数和锚点
                const cleanUrl = url.split('?')[0].split('#')[0];
                
                // 提取文件名
                const pathParts = cleanUrl.split('/');
                const fileName = pathParts[pathParts.length - 1];
                
                // 如果文件名存在且包含扩展名，返回文件名
                if (fileName && fileName.includes('.')) {
                    return fileName;
                }
                
                return null;
            } catch (error) {
                console.error('提取文件名失败:', error);
                return null;
            }
        },

        // 获取页面数据（图片、标题等）
        async getPageData() {
            try {
                // Get HOSTNAME from config
                const hostname = this.$config.HOSTNAME;
                
                // Initialize hostname_send
                let hostname_send = hostname;
                
                // Check if hostname starts with "pager"
                if (hostname && hostname.startsWith('pager')) {
                    hostname_send = '';
                } else {
                    hostname_send = hostname;
                }

                console.log('HOSTNAME:', hostname);
                
                if (hostname) {
                    const page_tag = 'index'; // 使用当前路由或默认值
                    const result = await this.$http.phamula.host_detail(hostname_send, page_tag);
                    
                    if (result.status === 'success' && result.data) {
                        this.pageData = result.data;
                        
                        // 更新页面标题
                        if (this.pageData.name) {
                            document.title = this.pageData.name + ' - Payment Successful';
                        }
                        
                        // 更新页面图片
                        if (this.pageData.obj_photo) {
                            this.image = this.pageData.obj_photo;
                        }
                        
                        // 更新 favicon
                        this.updateFavicon(this.pageData.obj_photo);
                    }
                }
            } catch (error) {
                console.error('获取页面数据失败:', error);
            }
        },

        // Favicon 更新方法（改进版）
        updateFavicon(imageUrl) {
            if (!imageUrl) return;
            
            // 方法1: 直接使用图片URL（现代浏览器支持）
            this.setFaviconDirect(imageUrl);
            
            // 方法2: 转换为ICO格式（备用方案）
            this.convertToIco(imageUrl);
        },

        // 直接设置 favicon
        setFaviconDirect(imageUrl) {
            try {
                // 移除现有的 favicon
                const existingLinks = document.querySelectorAll("link[rel*='icon']");
                existingLinks.forEach(link => {
                    if (link.parentNode) {
                        link.parentNode.removeChild(link);
                    }
                });

                // 添加新的 favicon
                const link = document.createElement('link');
                link.rel = 'icon';
                link.type = 'image/png'; // 或根据文件类型动态设置
                link.href = imageUrl + '?t=' + Date.now(); // 添加时间戳避免缓存
                document.head.appendChild(link);

                // 同时添加 shortcut icon（兼容性）
                const shortcutLink = document.createElement('link');
                shortcutLink.rel = 'shortcut icon';
                shortcutLink.href = imageUrl + '?t=' + Date.now();
                document.head.appendChild(shortcutLink);

            } catch (error) {
                console.error('设置 favicon 失败:', error);
            }
        },

        // 将图片转换为 ICO 格式（浏览器端）
        convertToIco(imageUrl) {
            const img = new Image();
            img.crossOrigin = 'anonymous'; // 处理跨域问题
            
            img.onload = () => {
                try {
                    // 创建 canvas
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');
                    
                    // 设置 favicon 标准尺寸
                    canvas.width = 32;
                    canvas.height = 32;
                    
                    // 绘制图片到 canvas
                    ctx.drawImage(img, 0, 0, 32, 32);
                    
                    // 转换为 data URL
                    const dataURL = canvas.toDataURL('image/png');
                    
                    // 设置为 favicon
                    const link = document.createElement('link');
                    link.rel = 'icon';
                    link.type = 'image/png';
                    link.href = dataURL;
                    document.head.appendChild(link);
                    
                } catch (error) {
                    // console.error('转换图片为 favicon 失败:', error);
                    // 降级到直接使用原图片
                    this.setFaviconDirect(imageUrl);
                }
            };
            
            img.onerror = () => {
                // console.error('加载图片失败:', imageUrl);
            };
            
            img.src = imageUrl;
        },

        // 检查主机名对应的 ICO 文件（备用方案）
        checkHostnameIco() {
            const hostname = this.$config.HOSTNAME;
            if (hostname) {
                const icoUrl = `/${hostname}.ico`;
                
                // 检查文件是否存在
                const img = new Image();
                img.onload = () => {
                    this.setFaviconDirect(icoUrl);
                };
                img.onerror = () => {
                    console.log('主机名对应的 ICO 文件不存在:', icoUrl);
                };
                img.src = icoUrl;
            }
        },

        // 获取订单数据
        async getOrderData() {
            // ?session_id=cs_test_Q0PTaYLsGdJOxiv9PyJhXkht1p94ngiXju4yezB4nRgqWa0EtDHquEdY
            console.log(JSON.parse(JSON.stringify(this.$route.query)));
            
            if (this.$route.query.session_id) {
                const req = {
                    stripe_session_id: this.$route.query.session_id
                };
                
                try {
                    const res = await this.$http.order.lists(req);
                    console.log(JSON.parse(JSON.stringify(res)));
                    
                    if (res.status === 'success') {
                        if (res.data.list.length) {
                            this.orderList = res.data.list;
                        } else {
                            this.$message('No order information available');
                        }
                    }
                } catch (error) {
                    console.error('获取订单数据失败:', error);
                    this.$message('Failed to load order information');
                }
            } else {
                this.$message('Invalid parameters');
            }
        }
    }
}
</script>


<style scoped lang="less">
    .success{
        display: flex;
        flex-wrap: wrap;
        .single-order h6{
            padding: 10px 0 5px;
            font-weight: normal;
        }
        .single-order p{
            color: #979797;
            font-size: 13.5px;
            line-height: 25px;
            padding-bottom: 5px;
        }
        
        // 确保 Digital Delivery 链接与其他文本大小一致
        /deep/ .download-link {
            color: #007bff;
            text-decoration: none;
            margin: 0 3px;
            padding: 1px 4px;
            border-radius: 3px;
            background-color: #f8f9fa;
            border: 1px solid #dee2e6;
            display: inline;
            transition: all 0.2s ease;
            font-size: inherit; // 继承父元素的字体大小
            font-family: inherit; // 继承父元素的字体
            line-height: inherit; // 继承父元素的行高
            
            &:hover {
                color: #0056b3;
                background-color: #e9ecef;
                text-decoration: underline;
                transform: translateY(-1px);
                box-shadow: 0 1px 3px rgba(0,0,0,0.1);
            }
            
            &:active {
                transform: translateY(0);
                box-shadow: 0 1px 2px rgba(0,0,0,0.1);
            }
            
            // // 为不同文件类型添加图标（可选）
            // &::before {
            //     content: "? ";
            //     margin-right: 2px;
            //     font-size: 0.9em;
            // }
            
            // // PDF文件特殊样式
            // &[href$=".pdf"]::before {
            //     content: "? ";
            // }
            
            // // 音频文件特殊样式
            // &[href$=".mp3"]::before,
            // &[href$=".wav"]::before,
            // &[href$=".m4a"]::before {
            //     content: "";
            // }
            
            // // 视频文件特殊样式
            // &[href$=".mp4"]::before,
            // &[href$=".avi"]::before,
            // &[href$=".mov"]::before {
            //     content: "? ";
            // }
            
            // // 图片文件特殊样式
            // &[href$=".jpg"]::before,
            // &[href$=".jpeg"]::before,
            // &[href$=".png"]::before,
            // &[href$=".gif"]::before {
            //     content: "?️ ";
            // }
            
            // // 压缩文件特殊样式
            // &[href$=".zip"]::before,
            // &[href$=".rar"]::before,
            // &[href$=".7z"]::before {
            //     content: "? ";
            // }
            
            // // 文档文件特殊样式
            // &[href$=".doc"]::before,
            // &[href$=".docx"]::before {
            //     content: "? ";
            // }
            
            // // 表格文件特殊样式
            // &[href$=".xls"]::before,
            // &[href$=".xlsx"]::before {
            //     content: "? ";
            // }
            
            // // 演示文稿文件特殊样式
            // &[href$=".ppt"]::before,
            // &[href$=".pptx"]::before {
            //     content: "?️ ";
            // }
            
            // // 文本文件特殊样式
            // &[href$=".txt"]::before {
            //     content: "? ";
            // }
            
            // // 代码文件特殊样式
            // &[href$=".js"]::before,
            // &[href$=".css"]::before,
            // &[href$=".html"]::before,
            // &[href$=".php"]::before,
            // &[href$=".py"]::before {
            //     content: "? ";
            // }
        }
        
        // 响应式设计
        @media (max-width: 768px) {
            /deep/ .download-link {
                display: inline-block;
                margin: 2px;
                padding: 4px 8px;
                
                &::before {
                    margin-right: 4px;
                }
            }
        }
        
        // 打印样式
        @media print {
            /deep/ .download-link {
                color: #000 !important;
                background-color: transparent !important;
                border: 1px solid #000 !important;
                text-decoration: underline !important;
                font-size: inherit !important;
                
                &::after {
                    content: " (" attr(href) ")";
                    font-size: 0.8em;
                    color: #666;
                }
                
                &::before {
                    display: none; // 打印时隐藏图标
                }
            }
        }
    }
</style>